import { ValidationError } from 'yup';

export const toYupValidationErrorString = (error: unknown) =>
  ValidationError.isError(error) ? error.errors[0] : undefined;
